import { I18nTextResource } from "common/resources/I18nText/I18nTextResource";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import { translateISO369 } from "utils/I18nText";
import classes from "./classes.module.scss";

type IProps = {
	value: I18nTextResource[];
};

export default function ProjectNeedsTag(props: IProps) {
	return (
		<div className={classes["root"]}>
			<Typography type="p" weight="medium" size="small" color="inherit">
				{I18n.asset.pages.project.project_needs}
			</Typography>
			<Typography type="p" weight="medium" size="small" color="inherit" className={classes["value"]}>
				{translateISO369(props.value)}
			</Typography>
		</div>
	);
}
